import { forwardRef } from 'react'
import { clsx } from 'clsx'

import type { TagPillProps } from './TagPill.types'

export const TagPill = forwardRef<HTMLSpanElement, TagPillProps>((props, ref) => {
  const { children, className, style, ...rest } = props

  return (
    <span ref={ref} className={clsx('TagPill', className)} style={style} {...rest}>
      {children}
    </span>
  )
})

TagPill.displayName = 'TagPill'
